<!-- begin::Quick Sidebar -->
<div id="m_quick_sidebar" class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light" appunwraptag="">
    <div class="m-quick-sidebar__content">
        <span id="m_quick_sidebar_close" class="m-quick-sidebar__close">
            <i class="la la-close"></i>
        </span>
        <div class="row g-0 justify-content-left" style="padding-bottom: 5px">
            <div style="display: flex; padding: 0px 9px">
                <button class="btn btn-primary btn-block btn-sidebar" (click)="updateFilters()">
                    <i class="fa fa-check" style="margin-right: 6px"></i>
                    Apply Current
                </button>

                <button
                    class="btn btn-block btn-sidebar"
                    style="background-color: #cc0000; color: white; border-color: #cc0000"
                    (click)="clearAllSelection()">
                    <i class="fa fa-times" style="margin-right: 6px"></i>
                    Clear All
                </button>

                <button
                    class="btn btn-block btn-sidebar"
                    style="background-color: #007a00; color: white; border-color: #007a00"
                    title="Save current selection with custom name"
                    (click)="showSaveSelectionModal()">
                    <i class="fa fa-save" style="margin-right: 6px"></i>
                    Save Selection
                </button>

                @if (savedSelections.length > 0) {
                    <div class="custom-dropdown">
                        <button
                            class="dropdown-toggle"
                            style="background-color: #997300; color: white; border-color: #997300"
                            type="button"
                            (click)="toggleDropdown()"
                            [class.active]="showDropdown">
                            <i class="fa fa-bookmark"></i>
                            {{ selectedSavedSelection || 'Load Saved Selection' }}
                            <i class="fa fa-chevron-down dropdown-arrow" [class.rotated]="showDropdown"></i>
                        </button>
                        <div class="dropdown-menu" [class.show]="showDropdown">
                            <div class="dropdown-header">
                                <span>Saved Selections</span>
                                <small>{{ savedSelections.length }} saved</small>
                            </div>
                            <div class="dropdown-items">
                                @for (selection of savedSelections; track trackBySelectionName($index, selection)) {
                                    <div class="dropdown-item">
                                        <div class="selection-info" (click)="loadSpecificSelection(selection.name)">
                                            <div class="selection-name">{{ selection.name }}</div>
                                            <div class="selection-count">
                                                {{ getSelectionCount(selection.value) }} hotels
                                            </div>
                                        </div>
                                        <div class="selection-actions">
                                            <button
                                                class="action-btn update-btn"
                                                (click)="updateSelection($event, selection.name)"
                                                title="Update this selection with current hotels">
                                                <i class="fa fa-refresh"></i>
                                            </button>
                                            <button
                                                class="action-btn delete-btn"
                                                (click)="deleteSelection($event, selection.name)"
                                                title="Delete this selection">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                            @if (savedSelections.length === 0) {
                                <div class="dropdown-footer">
                                    <span class="no-selections">No saved selections</span>
                                </div>
                            }
                        </div>
                    </div>
                }

                <button
                    class="btn btn-tertiary btn-block btn-sidebar"
                    title="Show a list of currently-selected hotels"
                    (click)="onShowClick()">
                    <i class="fa fa-list" style="margin-right: 6px"></i>
                    Show Current Selection
                </button>
            </div>
        </div>
        <div class="filter-flex wrap">
            <div
                class="modal"
                [class.show]="showSaveModal"
                [style.display]="showSaveModal ? 'block' : 'none'"
                style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1050;
                ">
                <div style="margin: 10vh auto; max-width: 500px; background: white; padding: 20px; border-radius: 5px">
                    <h5>
                        {{ isUpdateMode ? 'Update Hotel Selection' : 'Save Hotel Selection' }}
                    </h5>
                    <input
                        type="text"
                        [(ngModel)]="newSelectionName"
                        placeholder="Enter selection name..."
                        maxlength="50"
                        style="width: 100%; padding: 8px; margin: 10px 0; border: 1px solid #ccc; border-radius: 4px"
                        (keyup.enter)="saveNamedSelection()" />
                    <div style="color: #666; font-size: 12px; margin-bottom: 15px">
                        Current selection:
                        {{ entityMapFilters.get('hotel')?.selectedKeys?.length }}
                        hotel(s)
                        @if (isUpdateMode) {
                            <div style="font-style: italic; margin-top: 5px">
                                You can change both the name and hotel selection
                            </div>
                        }
                    </div>
                    <div style="text-align: right">
                        <button
                            (click)="hideSaveSelectionModal()"
                            style="
                                padding: 8px 16px;
                                margin-right: 10px;
                                background: #6c757d;
                                color: white;
                                border: none;
                                border-radius: 4px;
                                cursor: pointer;
                            ">
                            Cancel
                        </button>
                        <button
                            (click)="saveNamedSelection()"
                            [disabled]="!newSelectionName.trim()"
                            style="
                                padding: 8px 16px;
                                background: #007bff;
                                color: white;
                                border: none;
                                border-radius: 4px;
                                cursor: pointer;
                            "
                            [style.background]="!newSelectionName.trim() ? '#ccc' : '#007bff'">
                            {{ isUpdateMode ? 'Update' : 'Save' }}
                        </button>
                    </div>
                </div>
            </div>
            @for (filter of filters; track filter) {
                <div [hidden]="filter.hidden" [ngClass]="filter.className">
                    <div class="filter-header">
                        <span>{{ filter.textHeader }}</span>
                        @if (filter.headerF) {
                            <span
                                (click)="filter.headerF(filter)"
                                class="ico-f {{ filter.headerIco }}"
                                placement="left"
                                title="{{ filter.tooltip }}"></span>
                        }
                    </div>
                    <div class="filter-content">
                        @if (filter.id === 'hotel' && company === 'rhg') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="calc(33vh - 75px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a
                                        class="nav-link m-tabs__link"
                                        style="font-size: 14px"
                                        title="{{ node.id }}-{{ node.EMMA_CODE }}-{{ node.name }} ({{ node.htl_id }})">
                                        <span style="display: inline-block; width: 50px; margin: 0px 0px">{{
                                            node.id
                                        }}</span
                                        >-
                                        <span style="display: inline-block; width: 100px; margin: 0px 0px">{{
                                            node.EMMA_CODE
                                        }}</span
                                        >-
                                        <span style="margin-left: 5px">{{ node.name }}</span>
                                        @if (!checkAllowed(node?.htl_id)) {
                                            <span
                                                id="htl-warning"
                                                class="htl-warning"
                                                title="Excluded from current dashboard">
                                                <i class="la la-warning"></i>
                                            </span>
                                        }
                                    </a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.id === 'hotel' && company === 'lhg') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="calc(33vh - 75px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a
                                        class="nav-link m-tabs__link"
                                        style="font-size: 14px"
                                        title="{{ node.id }}-{{ node.EMMA_CODE }}-{{ node.name }} ({{ node.htl_id }})">
                                        <span style="display: inline-block; width: 70px; margin: 0px 0px">{{
                                            node.id
                                        }}</span
                                        >-
                                        <span style="margin-left: 5px">{{ node.name }}</span>
                                        @if (!checkAllowed(node?.htl_id)) {
                                            <span
                                                id="htl-warning"
                                                class="htl-warning"
                                                title="Excluded from current dashboard">
                                                <i class="la la-warning"></i>
                                            </span>
                                        }
                                    </a>
                                </div>
                            </dx-list>
                        }
                        @if (
                            filter.type &&
                            filter.id !== 'hotel' &&
                            filter.id !== 'theatre' &&
                            filter.id !== 'rmc_flag' &&
                            filter.id !== 'cc'
                        ) {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="calc(33vh - 75px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                itemTemplate="nodes"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link" title="{{ node[filter.textKey] }}">{{
                                        node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.type && filter.id !== 'hotel' && filter.id === 'theatre') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="calc(33vh - 75px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link">{{
                                        node[filter.textKey] == 1000
                                            ? 'EMEA'
                                            : node[filter.textKey] == 2000
                                              ? 'APAC'
                                              : node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.type && filter.id !== 'hotel' && filter.id === 'rmc_flag') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="calc(33vh - 75px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link" title="{{ node[filter.textKey] }}">{{
                                        node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (filter.type && filter.id !== 'hotel' && filter.id === 'cc') {
                            <dx-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.listSource"
                                height="calc(33vh - 75px)"
                                [showSelectionControls]="true"
                                [selectionMode]="filter.typeList"
                                selectAllMode="allPages"
                                [searchEnabled]="filter.searchExpr !== undefined"
                                [searchExpr]="filter.searchExpr"
                                [(selectedItemKeys)]="filter.selectedKeys"
                                itemTemplate="nodes"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)">
                                <div *dxTemplate="let node of 'nodes'">
                                    <a class="nav-link m-tabs__link" title="{{ node[filter.textKey] }}">{{
                                        node[filter.textKey]
                                    }}</a>
                                </div>
                            </dx-list>
                        }
                        @if (!filter.type) {
                            <dx-tree-list
                                #dxComponents
                                [disabled]="filter.disabled"
                                [elementAttr]="{ id: filter.id }"
                                [dataSource]="filter.treeSource"
                                height="calc(33vh - 75px)"
                                keyExpr="{{ filter.idKey }}"
                                parentIdExpr="parent"
                                [showRowLines]="false"
                                [showBorders]="false"
                                [columnAutoWidth]="true"
                                [showColumnHeaders]="true"
                                [(selectedRowKeys)]="filter.selectedKeys"
                                (onSelectAllValueChanged)="onFilterChange($event, filter, true)"
                                (onSelectionChanged)="onFilterChange($event, filter, false)"
                                [scrolling]="{ useNative: true }">
                                <dxo-selection mode="multiple" [recursive]="true" [allowSelectAll]="true">
                                </dxo-selection>
                                <dxi-column
                                    dataField="{{ filter.textKey }}"
                                    [allowSorting]="false"
                                    caption="Select All">
                                </dxi-column>
                            </dx-tree-list>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>
<!-- end::Quick Sidebar -->
<div id="hotelList" [ngClass]="showHotelList ? 'active' : 'inactive'">
    <div class="hotel-inner">
        <div class="hotel-box">
            <div
                class="hotel-box-inner hotel-box-inner clearfix"
                [ngClass]="showHotelList ? 'hotel-box-inner_active' : 'hotel-box-inner_inactive'">
                <h2>Selected Hotels</h2>
                <table
                    id="hotelListDataTable"
                    class="text-align-center swiper-no-swiping table-hover"
                    style="width: 100%"></table>
                <button
                    class="btn btn-secondary float-right"
                    style="width: 100px; margin-top: 10px"
                    (click)="onHotelClose()">
                    Ok
                </button>
            </div>
        </div>
    </div>
</div>
